<template>
  <DialogTemplate style="min-width: clamp(1px, 28rem, 100vw); min-height: 0">
    <SolfigrNodeEdit
      ref="form"
      :namespace="tmpNamespace"
      :primaryNamespace="namespace"
      :editTree="dialog.edit === 'tree'"
      :editSolution="dialog.edit === 'solution'"
      @close="close"
    />

    <template #dialog_actions>
      <portal-target name="dialog_actions" />
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
// import SolfigrSaveTree from '@/components/Dialogs/Solfigr/SolfigrSaveTree'
import SolfigrNodeEdit from '@/components/Dialogs/Solfigr/SolfigrNodeEdit'

export default {
  name: 'SolfigrNodeEditDialog',
  components: {
    SolfigrNodeEdit,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {}
  },
  methods: {
    apply() {
      if (this.$refs.form) {
        this.$refs.form.apply()
      }
    },
    handleKeyPress(keys) {
      if (this.$refs.form) {
        this.$refs.form.handleKeyPress(keys)
      }
    },
    close() {
      this.$store.dispatch('router_rm_dialog', 'solfigr-nodeedit-dialog')
    },
  },
  computed: {
    namespace() {
      return this.dialog.namespace || ''
    },
    tmpNamespace() {
      return this.dialog.tmpNamespace || ''
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .save-preset-form {
    margin-top: 1.5rem;
  }
}
</style>
